module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content_all2",
    attrs: {
      "id": "join_us"
    }
  }, [_c('div', {
    staticClass: "content_box"
  }, [_c('div', {
    staticClass: "list_box w700"
  }, [_c('div', {
    staticClass: "y_ititle2"
  }, [_vm._v("國立臺灣大學校總區戶外球場網路抽籤申請書")]), _vm._v(" "), _c('div', {
    staticClass: "jubox"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v("申請年度")]), _vm._v(" "), _c('td', [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.recordToEditApply.rocYear),
      callback: function($$v) {
        _vm.$set(_vm.recordToEditApply, "rocYear", $$v)
      },
      expression: "recordToEditApply.rocYear"
    }
  }, _vm._l((_vm.yearList), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("申請系所")]), _vm._v(" "), _c('td', [_c('Input', {
    model: {
      value: (_vm.recordToEdit.unitName),
      callback: function($$v) {
        _vm.$set(_vm.recordToEdit, "unitName", $$v)
      },
      expression: "recordToEdit.unitName"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.unitType),
      expression: "recordToEdit.unitType"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.unitType, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "unitType", "1")
      }
    }
  }), _vm._v("大學部\n            "), _c('span', {
    staticClass: "ml15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.unitType),
      expression: "recordToEdit.unitType"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.unitType, "2")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "unitType", "2")
      }
    }
  }), _vm._v("研究所")]), _vm._v(" "), _c('span', {
    staticClass: "ml15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.unitType),
      expression: "recordToEdit.unitType"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.unitType, "3")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "unitType", "3")
      }
    }
  }), _vm._v(" 社團")])])], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("申請類別")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.teamType),
      expression: "recordToEdit.teamType"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.teamType, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "teamType", "1")
      }
    }
  }), _vm._v(" 男子籃球隊\n            "), _c('span', {
    staticClass: "ml15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.teamType),
      expression: "recordToEdit.teamType"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.teamType, "2")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "teamType", "2")
      }
    }
  }), _vm._v(" 男子排球隊")]), _vm._v(" "), _c('span', {
    staticClass: "ml15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.teamType),
      expression: "recordToEdit.teamType"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.teamType, "3")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "teamType", "3")
      }
    }
  }), _vm._v(" 男子足球隊")]), _vm._v(" "), _c('span', {
    staticClass: "ml15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.teamType),
      expression: "recordToEdit.teamType"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.teamType, "4")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "teamType", "4")
      }
    }
  }), _vm._v(" 棒球隊")]), _vm._v(" "), _c('div', {
    staticClass: "mt5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.teamType),
      expression: "recordToEdit.teamType"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "5"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.teamType, "5")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "teamType", "5")
      }
    }
  }), _vm._v(" 女子籃球隊\n            "), _c('span', {
    staticClass: "ml15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.teamType),
      expression: "recordToEdit.teamType"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "6"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.teamType, "6")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "teamType", "6")
      }
    }
  }), _vm._v(" 女子排球隊")]), _vm._v(" "), _c('span', {
    staticClass: "ml15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.teamType),
      expression: "recordToEdit.teamType"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "7"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.teamType, "7")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "teamType", "7")
      }
    }
  }), _vm._v(" 女子足球隊")]), _vm._v(" "), _c('span', {
    staticClass: "ml15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.teamType),
      expression: "recordToEdit.teamType"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "8"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.teamType, "8")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "teamType", "8")
      }
    }
  }), _vm._v(" 壘球隊")])]), _vm._v(" "), _c('div', {
    staticClass: "mt5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.teamType),
      expression: "recordToEdit.teamType"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "9"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.teamType, "9")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "teamType", "9")
      }
    }
  }), _vm._v(" 其他\n            "), _c('span', {
    staticClass: "ml5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.teamTypeOther),
      expression: "recordToEdit.teamTypeOther"
    }],
    staticClass: "input_style3",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.teamTypeOther)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "teamTypeOther", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("申請場館")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "mt5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.buildingGroup),
      expression: "recordToEdit.buildingGroup"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.buildingGroup, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "buildingGroup", "1")
      }
    }
  }), _vm._v(" 體育館\n                "), _c('span', {
    staticClass: "ml15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.buildingGroup),
      expression: "recordToEdit.buildingGroup"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.buildingGroup, "2")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "buildingGroup", "2")
      }
    }
  }), _vm._v(" 綜合體育館")])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('tr', [_c('th', [_vm._v("姓名")]), _vm._v(" "), _c('td', [_c('Input', {
    model: {
      value: (_vm.recordToEdit.contactName),
      callback: function($$v) {
        _vm.$set(_vm.recordToEdit, "contactName", $$v)
      },
      expression: "recordToEdit.contactName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("學號")]), _vm._v(" "), _c('td', [_c('Input', {
    model: {
      value: (_vm.recordToEdit.contactSchoolId),
      callback: function($$v) {
        _vm.$set(_vm.recordToEdit, "contactSchoolId", $$v)
      },
      expression: "recordToEdit.contactSchoolId"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("電話")]), _vm._v(" "), _c('td', [_c('Input', {
    model: {
      value: (_vm.recordToEdit.contactMobile),
      callback: function($$v) {
        _vm.$set(_vm.recordToEdit, "contactMobile", $$v)
      },
      expression: "recordToEdit.contactMobile"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_c('Input', {
    model: {
      value: (_vm.recordToEdit.contactEmail),
      callback: function($$v) {
        _vm.$set(_vm.recordToEdit, "contactEmail", $$v)
      },
      expression: "recordToEdit.contactEmail"
    }
  })], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center tx14",
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agree),
      expression: "agree"
    }],
    attrs: {
      "name": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agree) ? _vm._i(_vm.agree, null) > -1 : (_vm.agree)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agree = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agree = $$c
        }
      }
    }
  }), _vm._v(" 我已閱讀相關注意事項")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tomi mt15"
  }, [_c('button', {
    staticClass: "btn_m",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("送出申請")]), _vm._v(" "), _c('button', {
    staticClass: "btn_n",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("回上一頁")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "y_ititle2"
  }, [_vm._v("負責人 / 聯絡人")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "pt15 pb15",
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "psbox"
  }, [_vm._v("注意事項")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a196d904","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/rent/JoinUs.vue
// module id = 1280
// module chunks = 3